export default __webpack_public_path__ + "static/media/bg-pattern-desktop.f51e07a2.svg";